import React from "react";
import Typography from "@mui/material/Typography";
import { Link } from 'react-router-dom';
import { PageTitle, ParaTitle, Paragraph, Pagination } from "../common";

const EventStatus = () => {
    return (
        <div>
            <PageTitle title='Event Status' role='Any role except user' />
            <ParaTitle paraTitle='Overview' />
            <Paragraph paragraph='All events that exist have certain information tied to them. Events also have an event status. This status determines who can view the event, what related information can be changed, and what actions can be taken to change the event status. Below is a list of all event statuses which describes who has access to events with that status and what must be done to change the event status.' />

            <ParaTitle paraTitle='Draft' />
            <Paragraph paragraph='Anyone can create, edit, view, and delete an event in the draft stage as long as they are the one who created it. Note this is the only type of event that the role "User" has access to and it does not have an associated event summary page.' />

            <Typography variant="paragraph" component="div">
                Learn more about drafts in the <Link to='/general/adding-new-event'>Add an event</Link> section.
            </Typography>

            <ParaTitle paraTitle='New Event' />
            <Paragraph paragraph='Newly created events have status "New Event" by default. Roles that have the privileges of a Risk Manager are able to view new events and change the event information. Assigning a reviewer will change the event status to "Under Review".' />
            <Typography variant="paragraph" component="div">
                Learn more about assigning reviewers in the <Link to='/risk-manager/assign-reviewers'>assigning reviewers</Link> section.
            </Typography>

            <ParaTitle paraTitle='Under Review' />
            <Paragraph paragraph='An event with a reviewer assigned to it has the status of "Under Review". Roles with Risk Manager privileges can have access to these events but reviewers who are assigned to the event will have access as well. To change the status to "Review Completed" all assigned reviewers must have closed their reviews.' />
            <Typography variant="paragraph" component="div">
                Learn more about reviewing in the <Link to='/reviewer/complete-review'>reviewing</Link> section.
            </Typography>

            <ParaTitle paraTitle='Review Completed' />
            <Paragraph paragraph='An event whose reviews have all been closed will have its status change to "Review Completed". Roles with Risk Manager privileges will have access to these events and can modify their information. The status can be changed to "Pending Approval" by requesting approval for the event in the event summary page.' />
            <Typography variant="paragraph" component="div">
                Learn more about requesting approval in the <Link to='/risk-manager/requesting-approval'>Requesting Approval</Link> section.
            </Typography>

            <ParaTitle paraTitle='Pending Approval' />
            <Paragraph paragraph='After an event has been requested for approval it has the status of "Pending Approval". Roles with Approver or Risk Manager privileges have access to these events. Note that only event information related to comments can be changed for an event that is pending approval. The Approver can either approve or reject an event to change the event status to "Closed Event" or "Approval Rejected" respectively.' />
            <Typography variant="paragraph" component="div">
                Learn more about approving an event in the <Link to='/approver/approve-events'>approving events</Link> section.
            </Typography>

            <ParaTitle paraTitle='Approval Rejected' />
            <Paragraph paragraph='Events with the "Approval Rejected" status require a role with Risk Manager privileges for access. The status can be changed to "Under Review" by assigning a reviewer.' />
            <Typography variant="paragraph" component="div">
                Learn more about assigning reviewers in the <Link to='/risk-manager/assign-reviewers'>assigning reviewers</Link> section.
            </Typography>

            <ParaTitle paraTitle='Closed Event' />
            <Paragraph paragraph='Closed events can be viewed by roles with Risk Manager privileges. Only information related to comments can be changed.' />

            <Pagination
                pagination={{
                    prev: { name: 'Events Summary', link: '/general/events-summary' },
                    next: { name: 'Adding New Event', link: '/general/adding-new-event' }
                }}
            />


        </div>
    );
};

export default EventStatus;
